<template>
  <el-form-item :label="currentField.label" :label-width="currentField.labelWidth + 'px'">
    <el-input
        type="textarea"
        :rows="2"
        :placeholder="currentField.isPlaceholderVisible ? currentField.placeholder : ''"
        v-model="currentField.componentValue"
        v-bind="attributesBinding"
        v-on:change="textAreaChange"
        class="custom-textarea"
    ></el-input>
    <el-button v-if="showCopyButton" type="primary" size="mini" icon="el-icon-document-copy"
               @click="copyPlaceholder"></el-button>
  </el-form-item>
</template>

<script>

export default {
  name: 'LongTextInput',
  props: ['currentField'],
  data() {
    return {
      // textarea: ''
      showCopyButton: false
    };
  },
  mounted() {
    this.showCopyButtonCheck();
    this.$hub.$on('printInProgress', (data) => {
      this.showCopyButton = false;
    });
    this.$nextTick(() => {
      const textarea = this.$el.querySelector('textarea');
      if (textarea) {
        textarea.style.height = 'auto';
        textarea.style.height = `${textarea.scrollHeight + 4}px`;
      }
    });
  },
  methods: {
    showCopyButtonCheck() {
      // Show copy button if placeholder text length is greater than 1
      return this.currentField.isPlaceholderVisible && this.currentField.placeholder && this.currentField.placeholder.length > 1;
    },
    textAreaChange(value) {
      this.currentField.componentValue = value;
    },
    copyPlaceholder() {
      // Check if navigator.clipboard is supported
      if (navigator.clipboard && navigator.clipboard.writeText) {
        // Copy placeholder text to clipboard
        navigator.clipboard.writeText(this.currentField.placeholder)
            .then(() => {
              // Success message or any other action
              this.$message.success('Placeholder text copied to clipboard');
            })
            .catch(err => {
              console.error('Failed to copy placeholder text: ', err);
              this.$message.error('Failed to copy placeholder text');
            });
      } else {
        // Fallback for browsers that do not support clipboard API
        console.warn('Clipboard API not supported in this browser');
        // You can provide a fallback mechanism here, such as using a library like clipboard.js
        // or displaying a message to the user that the feature is not available
      }
    }

  },
  computed: {
    attributesBinding() {
      var attr = {};
      if (this.currentField.disabled) {
        attr.disabled = this.currentField.disabled;
      }
      return attr;
    },

  },
};
</script>
<style scoped>
.custom-textarea .el-textarea__inner {
  width: 100%; /* Adjust as needed */
  overflow-y: hidden !important; /* Hide the vertical scrollbar */
  resize: none; /* Prevent resizing */
}
</style>
